angular
  .module('fg')
  .factory('fgPropertyFieldOptionsLinkFn', function () {
    return function ($scope, $element, $attrs) {
      $scope.multiple = false;

      $attrs.$observe('fgPropertyFieldOptions', function (value) {
        if (value === 'multiple') {
          $scope.multiple = true;
        }
      });

      var el = $element[0];
      var ctrl = $scope.optionsCtrl;

      function getOptionRow(target) {
        var node = target;
        while (node && node !== el) {
          if (node.classList && node.classList.contains('fg-option-row')) {
            return node;
          }
          node = node.parentElement;
        }
        return null;
      }

      function getWrapper(target) {
        var node = target;
        while (node && node !== el) {
          if (node.classList && node.classList.contains('fg-option-wrapper')) {
            return node;
          }
          node = node.parentElement;
        }
        return null;
      }

      function getRowIndex(row) {
        var attr = row.getAttribute('data-option-index');
        return attr !== null ? parseInt(attr, 10) : -1;
      }

      function getWrapperIndex(wrapper) {
        var row = wrapper.querySelector('.fg-option-row');
        return row ? getRowIndex(row) : -1;
      }

      function isNoOpDrop(targetIndex) {
        return (
          targetIndex === ctrl.dragIndex || targetIndex === ctrl.dragIndex + 1
        );
      }

      var handles = [];

      function setupDragHandles() {
        handles.forEach(function (h) {
          h.el.removeEventListener('mouseenter', h.enter);
          h.el.removeEventListener('mouseleave', h.leave);
        });
        handles = [];

        var dragHandles = el.querySelectorAll('.fg-options-drag-handle');
        for (var i = 0; i < dragHandles.length; i++) {
          (function (handle) {
            var row = handle.closest('.fg-option-row');
            if (!row) return;

            var enterFn = function () {
              row.setAttribute('draggable', 'true');
            };
            var leaveFn = function () {
              row.removeAttribute('draggable');
            };

            handle.addEventListener('mouseenter', enterFn);
            handle.addEventListener('mouseleave', leaveFn);

            handles.push({ el: handle, enter: enterFn, leave: leaveFn });
          })(dragHandles[i]);
        }
      }

      $scope.$watchCollection('field.options', function () {
        setTimeout(setupDragHandles, 0);
      });

      function onDragStart(e) {
        var row = getOptionRow(e.target);
        if (!row) return;

        e.stopPropagation();

        var index = getRowIndex(row);
        if (index === -1) return;

        e.dataTransfer.effectAllowed = 'move';
        e.dataTransfer.setData('text/plain', '');

        $scope.$apply(function () {
          ctrl.dragIndex = index;
          ctrl.dropTargetIndex = -1;
        });
      }

      function onDragOver(e) {
        if (ctrl.dragIndex === -1) return;
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        e.dataTransfer.dropEffect = 'move';

        var wrapper = getWrapper(e.target);
        var targetIndex;

        if (wrapper) {
          var wrapperIndex = getWrapperIndex(wrapper);
          if (wrapperIndex === -1) return;

          var rect = wrapper.getBoundingClientRect();
          var midY = rect.top + rect.height / 2;
          targetIndex = e.clientY < midY ? wrapperIndex : wrapperIndex + 1;
        } else {
          // Check if over the trailing fg-dropzone (after the last wrapper)
          var optionsList = el.querySelector('.fg-options-list');
          if (!optionsList) return;

          var lastDropzone = optionsList.querySelector(
            ':scope > fg-dropzone:last-child'
          );
          if (lastDropzone && lastDropzone.contains(e.target)) {
            targetIndex = $scope.field.options.length;
          } else {
            return;
          }
        }

        if (isNoOpDrop(targetIndex)) {
          if (ctrl.dropTargetIndex !== -1) {
            $scope.$apply(function () {
              ctrl.dropTargetIndex = -1;
            });
          }
          return;
        }

        if (targetIndex !== ctrl.dropTargetIndex) {
          $scope.$apply(function () {
            ctrl.dropTargetIndex = targetIndex;
          });
        }
      }

      function onDrop(e) {
        if (ctrl.dragIndex === -1) return;
        e.preventDefault();
        e.stopPropagation();

        $scope.$apply(function () {
          ctrl.onDrop(ctrl.dropTargetIndex);
        });
      }

      function onDragEnd(e) {
        if (ctrl.dragIndex === -1) return;
        e.stopPropagation();

        $scope.$apply(function () {
          ctrl.onDragEnd();
        });
      }

      el.addEventListener('dragstart', onDragStart, true);
      el.addEventListener('dragover', onDragOver, true);
      el.addEventListener('drop', onDrop, true);
      el.addEventListener('dragend', onDragEnd, true);

      $scope.$on('$destroy', function () {
        el.removeEventListener('dragstart', onDragStart, true);
        el.removeEventListener('dragover', onDragOver, true);
        el.removeEventListener('drop', onDrop, true);
        el.removeEventListener('dragend', onDragEnd, true);

        handles.forEach(function (h) {
          h.el.removeEventListener('mouseenter', h.enter);
          h.el.removeEventListener('mouseleave', h.leave);
        });
        handles = [];
      });
    };
  })
  .directive('fgPropertyFieldOptions', [
    'fgPropertyFieldOptionsLinkFn',
    function (fgPropertyFieldOptionsLinkFn) {
      return {
        scope: true,
        controller: 'fgPropertyFieldOptionsController as optionsCtrl',
        templateUrl:
          'angular-form-gen/edit/canvas/field/properties/options/options.ng.html',
        link: fgPropertyFieldOptionsLinkFn
      };
    }
  ]);
